import React, {Component} from "react";

import * as types from "./../../../constants/componentTypes";

import BuildingSiteListModal from "./modal/BuildingSiteListModal";
import ChangeDatabaseModal from "../../global/modal/ChangeDatabaseModal";
import ChangeLogModal from "../../global/modal/ChangeLogModal";
import CleanChannelsModal from "../default/modal/CleanChannelsModal";
import DebugModal from "../../global/modal/DebugModal";
import DatePickerModal from "../../global/modal/DatePickerModal";
import DispensingQuickTintModal from "../../global/modal/DispensingQuickTintModal";
import MachineErrorsModal from "../../global/modal/MachineErrorsModal";
import MeasurementDetailModal from "./modal/MeasurementDetailModal";
import OrderNotificationModal from "../../../containers/modal/OrderNotificationModal";
import PrintModal from "../../global/modal/PrintModal";
import PrintPreviewOrderModal from "../../global/modal/PrintPreviewOrderModal";
import * as componentTypes from "../../../constants/componentTypes";
import PartialUpdatesModal from "../default/modal/PartialUpdatesModal";

export default class Modal extends Component {
    render() {
        switch (this.props.type) {
            case types.BUILDING_SITE_LIST_MODAL:
                return <BuildingSiteListModal {...this.props} />;
            case types.CHANGE_DATABASE_MODAL:
                return <ChangeDatabaseModal {...this.props} />;
            case types.CHANGELOG_MODAL:
                return <ChangeLogModal {...this.props} />;
            case types.CLEAN_CHANNELS_MODAL:
                return <CleanChannelsModal {...this.props} />;
            case types.DEBUG_MODAL:
                return <DebugModal {...this.props} />;
            case types.DATE_PICKER_MODAL:
                return <DatePickerModal {...this.props} />;
            case types.DISPENSING_QUICK_TINT_MODAL:
                return <DispensingQuickTintModal {...this.props} />;
            case types.MACHINE_ERRORS_MODAL:
                return <MachineErrorsModal {...this.props} />;
            case types.SPECTRO_MEASUREMENT_DETAIL_MODAL:
                return <MeasurementDetailModal {...this.props} />;
            case types.ORDER_NOTIFICATION_MODAL:
                return <OrderNotificationModal {...this.props} />;
            case componentTypes.PARTIAL_UPDATE_MODAL:
                return <PartialUpdatesModal {...this.props} />;
            case types.PRINT_MODAL:
                return <PrintModal {...this.props} />;
            case types.PRINT_PREVIEW_ORDER_MODAL:
                return <PrintPreviewOrderModal {...this.props} />;
            default:
                return <div />;
        }
    }
}
